<template>
  <div>
      <div class="ly-card">
          <div class="nav_car">
              <div class="car">订单管理 &nbsp;&nbsp;&gt;&nbsp;&nbsp;订单审核</div>
              <div class="car"><span>状态:&nbsp;{{ "待审核" }}</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span>申请时间:&nbsp;{{ detialInfo.CREATE_TIME }}</span></div>
              <el-button class="car_btn refuse_btn" @click="handleRefuse()">驳回</el-button>   
              <el-button class="car_btn" type="primary" @click="handlePass()">通过</el-button>
              <el-button class="car_btn" type="primary" @click="goBack()">返回</el-button>
          </div>
          <div class="content">
                <div class="detail_content">
                    <div class="detail_title">申请详情</div>
                    <div class="detail_info">
                        <div>姓名: {{ detialInfo.USER_DISPLAY_NAME }}</div>
                        <div>手机号: {{ detialInfo.USER_MOBILE }}</div>
                        <div>下单时间: {{ detialInfo.PAYMENT_TIME }}</div>
                        <div>退款金额：{{ detialInfo.REFUND_AMOUNT }}</div>
                        <div>实付金额：{{ detialInfo.PAYMENT_AMOUNT_ACTUAL }}</div>
                        <div>退款说明：{{ detialInfo.REMARK }}</div>
                        <div>商品详情： {{ detialInfo.SERVICE_THEME }}</div>
                        <div>订单号: {{ detialInfo.ORDER_NUM }}</div>
                    </div>
                </div>
                <div class="detail_content">
                    <div class="detail_title">驳回原因(申请驳回时填写)</div>
                    <div class="refuse_text">
                        <el-input
                            v-model="Refuse.reason"
                            type="textarea"
                            :autosize="{ minRows: 4 }"
                            show-word-limit
                            placeholder="此处填写驳回原因!"
                        ></el-input> 
                    </div>
                </div>
          </div>
      </div>
  </div>
</template>

<script>
export default {
    data() {
        return {
            detialInfo: {},
            refuseDialog: false,
            Refuse: {
                reason: '',
            },
            ORDER_ID: 0,//订单ID
            REFUND_ID: 0,//退款ID
            orderQuery: {}
        }
    },
    mounted() {
        
        this.ORDER_ID = this.$route.query.ORDER_ID
        this.REFUND_ID = this.$route.query.REFUND_ID
        this.orderQuery = JSON.parse(window.sessionStorage.getItem("orderQuery"))
        // 获取退款详情
        this.getDetail()
    },
    methods: {
        // 返回上一级
        goBack() {
            this.$router.back()
        },
        // 获取退款详情信息
        getDetail() {
            this.$axios.post(`orderApiSvr/Order/GetRefundInfoDetail`,{
                refundId: this.REFUND_ID
            }).then(res => {
                if(res.code == 200 || res.code == 0) {
                    if(res.data) {
                        this.detialInfo = res.data
                    }
                }
            })
        },
        // 通过申请
        handlePass() {
            this.$axios.post(`orderApiSvr/Order/AgreeRefund`,{
                 refundInfo: {
                    ORDER_ID: this.ORDER_ID,
                    ORDER_NUM: this.orderQuery.ORDER_NUM,
                    REFUND_AMOUNT: this.orderQuery.REFUND_AMOUNT,
                    REFUND_AMOUNT_ACTUAL: this.orderQuery.REFUND_AMOUNT_ACTUAL,
                    ORDER_NUM_2: this.orderQuery.ORDER_NUM_2
                }
            }).then(res=> {
                if(res.code == 200 || res.code == 0) {
                    if(res.data) {
                        this.$message.success('审核通过')
                        this.goBack()
                    } else {
                        this.$message.error('审核失败')
                    }
                }
            })
        },
        // 拒绝申请
        handleRefuse() {
            if(this.Refuse.reason) {
                let self = this
                self.$confirm("是否拒绝申请？", "提示").then(() =>{
                    console.log(self.ORDER_ID)
                self.$axios.post(`orderApiSvr/Order/DisagreeRefund`,{
                        refundInfo: {
                            ORDER_ID: self.ORDER_ID,
                            OUT_MSG: self.Refuse.reason
                        }
                    }).then(res => {
                        if(res.code == 200 || res.code == 0) {
                            if(res.data) {
                                self.$message.success('驳回成功')
                                self.goBack()
                            } else {
                                self.$message.error('驳回失败')
                            }
                        } else {
                            self.$message.error('操作失败')
                        }
                    })
                })
            } else {
                this.$message.error('请填写驳回原因！！')
            }
             
        }
    }
}
</script>

<style lang="less" scoped>
.nav_car {
    display: flex;
    min-height: 80px;
    align-items: center;
    .car {
        height: 40px;
        padding: 0 30px;
        line-height: 40px;
        text-align: center;
        box-shadow: 0px 0px 20px #00000059;
        border-radius: 10px;
        margin-right: 10px;
        font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
        font-weight: 700;
        font-style: normal;
        color: #171C49;
        font-size: 14px;
    }
    .car_btn {
        border-radius: 10px;
        box-shadow: 0px 0px 20px #00000059;
    }
}
.content {
    padding: 0;
    margin-bottom: 20px;
    min-width: 500px;
    .detail_title {
        font-weight: 700;
        font-style: normal;
        color: #171C49;
        padding: 0 30px;
        line-height: 45px;
        background-color:rgba(242, 242, 242, 1);
        height: 45px;
    }
    .detail_content {
        border: 2px solid #f2f2f2;
        margin-bottom: 20px;
        border-radius: 10px;
    }
    .detail_info {
       padding: 0 30px; 
       margin-bottom: 10px;
       line-height: 40px;
        font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
        font-weight: 700;
        font-style: normal;
        color: #171C49;
        font-size: 14px;
    }
}
.refuse_btn {
    background: #E6A23C;
    color: #fff;
    border: 1px solid #E6A23C;
}
.refuse_title {
    font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
    font-weight: 700;
    font-style: normal;
    color: #171C49;
    font-size: 24px;
    line-height: 40px;
    text-align: center;
}
.dialog_content {
    font-family: 'Arial Negreta', 'Arial Normal', 'Arial';
    font-weight: 700;
    font-style: normal;
    color: #171C49;
    font-size: 18px;
    line-height: 40px;
}
.dialog_btn {
    text-align: right;
}
.refuse_text {
    padding: 30px;
}
</style>


// WEBPACK FOOTER //
// src/views/orders/refundDetail.vue